export const entityLabels = {
  company: { singular: 'company', plural: 'companies' },
  person: { singular: 'person', plural: 'people' },
} as const;

export type EntityType = keyof typeof entityLabels;

export function getEntityLabel(entityType: EntityType, count: number): string {
  const { singular, plural } = entityLabels[entityType];
  return count === 1 ? singular : plural;
}
